export default __webpack_public_path__ + "static/media/Forest Random NPCs 1-1710416878371.54582647.PNG";